import React from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
import NewFormWizard from '../../../../components/formWizard/NewFormWizard'
import FormWizardChild from '../../../../components/formWizard/FormWizardChild'
import Layout from '../../../../components/layouts/Layout'
import { eventAppExperienceBranding } from '../slice/createEventSlice'

const AppExperience = () => {
    const history = useHistory();
    const dispatch = useDispatch()
    const {register, handleSubmit} = useForm()
    const handleAppExperience = (data) => {
        dispatch(eventAppExperienceBranding(data))
        // history.push('/event/summary')
    }
    return (
        <Layout>
            <NewFormWizard  />
            {/* <FormWizardChild /> */}
            <section className="my-5">
                <div className="row">
                    <div className="text-center col-12 col-ma-12">
                        <div className="pb-4">
                            <p className="mb-0 font-size-25">App Experience</p>
                            <p className="mb-0 font-size-16">Set your branding below</p>
                        </div>
                    </div>
                </div>
                <form onSubmit={handleSubmit(handleAppExperience)}>
                    <div className="card">
                    <div className="card-body">
                        <div className="my-5 tab__menu__app__experience d-flex justify-content-around">
                            <div className="tab__layouts">
                                <p className="mb-0 uppercase font-size-16 font-weight-600">Photo Booth</p>
                            </div>
                            <div className="tab__layouts">
                                <p className="mb-0 uppercase font-size-16 font-weight-600">Sharing Station</p>
                            </div>
                        </div>
                        <div className="sharing">
                            <div className="my-3 row">
                                <div className="col-md-6">
                                    <button className="capitalize btn btn-primary btn-block">Attract screen library</button>
                                </div>
                                <div className="col-md-3">
                                    <button className="capitalize btn btn-primary btn-block">view recommended size</button>
                                </div>
                                <div className="col-md-3">
                                    <button className="capitalize btn btn-primary btn-block">reset background</button>
                                </div>
                            </div>
                            <div className="row">
                        <div className="col-md-6">
                        <div className="upload__area">
                            <span className="capitalize">upload animated background</span>
                            <div className="attract__screen__upload">
                                    <label className="custom-file-upload">
                                        <input type="file" {...register("animated_bg")}  />
                                        Upload
                                    </label>
                            </div>
                        </div>
                        <div className="upload__area">
                            <span className="capitalize">upload animated background</span>
                            <div className="attract__screen__upload">
                                    <label className="custom-file-upload">
                                        <input type="file"  />
                                        Upload
                                    </label>
                            </div>
                        </div>
                        <div className="upload__area">
                            <span className="capitalize">upload animated background</span>
                            <div className="attract__screen__upload">
                                    <label className="custom-file-upload">
                                        <input type="file"   />
                                        Upload
                                    </label>
                            </div>
                        </div>
                        </div>
                        <div className="col-md-3">
                            
                        </div>
                        <div className="col-md-3">
                            
                        </div>
                    </div>
                        </div>
                    </div>
                </div>
                    <div className="my-5 row">
                    <div className="col-md-12">
                        <button type="button" className="float-left btn btn-outline-info">Back</button>
                        <button type="submit" className="float-right btn btn-outline-info">Next</button>
                    </div>
                </div>
                </form>
            </section> 
        </Layout>
    )
}

export default AppExperience
